(() => {
    let checkCookieInterval = '';
    let clickedLink = '';
    const initStateReady = () => {
        document.querySelectorAll('.atom-button__download').forEach((item) => {
            item.addEventListener('click', () => {
                if (item.getAttribute('href') !== null) {
                    document.cookie = 'downloadFinished=false;path=/';
                    clickedLink = item;
                    clickedLink.parentNode.querySelector('.download-link-loader-overlay').classList.add('show');
                    checkCookieInterval = setInterval(checkCookie, 1000);
                    toggleLink(clickedLink, true);
                }
            });
        });
    };

    function toggleLink(clickedLink, removeLinks = false) {
        document.querySelectorAll('.atom-button__download').forEach((link) => {
            if (link !== clickedLink) {
                if (removeLinks) {
                    link.classList.add('inactiveLink');
                } else {
                    link.classList.remove('inactiveLink');
                }
            }
        });
    }

    function checkCookie() {
        let downloadFinished = getCookie('downloadFinished');
        if (downloadFinished === 'true') {
            clickedLink.parentNode.querySelector('.download-link-loader-overlay').classList.remove('show');
            document.cookie = 'downloadFinished=false;path=/';
            clearInterval(checkCookieInterval);
            toggleLink(clickedLink);
        }
    }

    function getCookie(name) {
        let match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
        if (match) {
            return match[2];
        }
    }

    document.addEventListener('readystatechange', () => {
        if (document.readyState !== 'complete') {
            return;
        }

        initStateReady();
    });
})();
